/**
 * SkeletonProviderCard - Loading placeholder for ProviderCard
 *
 * Displays a square shimmer animation matching ProviderCard dimensions.
 */

import type { ReactElement } from "react";
export function SkeletonProviderCard(): ReactElement {
  return (
    <div className="flex-shrink-0 self-start w-[140px] sm:w-[180px] snap-center">
      {/* Square image placeholder */}
      <div className="aspect-square overflow-hidden rounded-lg bg-neutral-800 animate-pulse" />
      {/* Name placeholder */}
      <div className="mt-2 h-4 w-3/4 mx-auto rounded bg-neutral-800 animate-pulse" />
    </div>
  );
}
